var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header',{staticClass:"header-at-home"}),_c('HeadSection',{staticClass:"head-at-home"}),_c('VariabilitySection',{staticClass:"variability-at-home"}),_c('CompetencySection',{staticClass:"competency-at-home"}),_c('ActivitiesSection',{staticClass:"activities-at-home"}),_c('Footer',{staticClass:"footer-at-home"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }